import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { OccSeatingScreenPosition } from '../../../context/occ/types/config/seating/screen-position';
import { SvgPathBuilder } from '../../../utils/svg-path-builder';
import { getScreenRectangle } from '../positioning/screen';
import { SeatPickerContextInstance } from '../types/context';
const b = bemClassBuilder('v-seat-picker-screen');
export const SeatPickerScreen = observer(props => {
    const i18n = useI18n();
    const { seatLayout, mapRectangle, scaleFactor, screen } = props;
    const { config, displayText } = useContext(SeatPickerContextInstance);
    const { x, y, width, height } = getScreenRectangle(seatLayout.screenBoundary, mapRectangle, scaleFactor, config);
    const label = displayText.screenNameFormat
        ? i18n.template(displayText.screenNameFormat, { screenName: i18n.translatable(screen.name) })
        : undefined;
    const screenBackgroundPath = getScreenBackgroundPath(width, height, config);
    return (_jsxs("svg", { className: b.block(), x: x, y: y, children: [_jsx("path", { className: b.element('background'), d: screenBackgroundPath }), label && label.length > 0 && (_jsx("text", { className: b.element('text'), x: width / 2, y: height / 2, dominantBaseline: "central", alignmentBaseline: "central", textAnchor: "middle", children: label }))] }));
});
SeatPickerScreen.displayName = 'SeatPickerScreen';
export function getScreenBackgroundPath(width, height, config) {
    const bevelOffset = config.screen.bevelOffset;
    if (config.screen.position === OccSeatingScreenPosition.Top) {
        return new SvgPathBuilder()
            .moveTo(0, 0)
            .drawLineRight(width)
            .drawLineTo(width - bevelOffset, height, true)
            .drawLineLeft(width - bevelOffset * 2)
            .drawLineTo(0, 0, true)
            .closePath()
            .toString();
    }
    return new SvgPathBuilder()
        .moveTo(bevelOffset, 0)
        .drawLineRight(width - bevelOffset * 2)
        .drawLineTo(width, height, true)
        .drawLineLeft(width)
        .drawLineTo(bevelOffset, 0, true)
        .closePath()
        .toString();
}
//# sourceMappingURL=screen.js.map